import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';

import {of, from, tap} from 'rxjs';
import { switchMap, map, catchError, withLatestFrom } from 'rxjs/operators';
import { Store } from '@ngrx/store';
import {AppState} from "../../../shared/state/app.state";
import {
  downloadReport,
  downloadReportFailure,
  downloadReportSuccess,
  generateReport,
  generateReportFailure,
  generateReportSuccess,
  loadReports,
  loadReportsFailure,
  loadReportsSuccess,
  loadReportValidationMessages, loadReportValidationMessagesFailure,
  loadReportValidationMessagesSuccess,
  removeReport,
  removeReportSuccess
} from "./report.action";
import {ReportService} from "../../data-access/report.service";
import {selectReports} from "./report.selectors";
import {Router} from "@angular/router";

@Injectable()
export class ReportEffects {

  loadReports$ = createEffect(() =>
    this.actions$.pipe(
      ofType(loadReports),
      switchMap(() =>
        this.reportService.get()
          .pipe(
            map((reports) => loadReportsSuccess({reports: reports})),
            catchError((error) => of(loadReportsFailure({ error })))
          )
      )
    )
  );

  generateReport$ = createEffect(() =>
    this.actions$.pipe(
      ofType(generateReport),
      switchMap((action) =>
        this.reportService.generate(action.buildKitId, action.reportType, action.fileName, action.settings)
          .pipe(
            map((generateStatus) => generateReportSuccess({generateStatus: generateStatus })),
            catchError((error) => of(generateReportFailure({ error })))
          )
      )
    )
  );

  downloadReport$ = createEffect(() =>
    this.actions$.pipe(
      ofType(downloadReport),
      switchMap((action) => {
          return this.reportService.download(action.reportId, action.fileName)
            .pipe(
              map((file) => downloadReportSuccess({file: file})),
              catchError((error) => of(downloadReportFailure({error})))
            )
        }
      )
    )
  );

  removeReport$ = createEffect(() =>
    this.actions$.pipe(
      ofType(removeReport),
      withLatestFrom(this.store.select(selectReports)),
      switchMap(([action, reportState]) => {
          return this.reportService.remove(action.reportId)
            .pipe(
              map((report) => removeReportSuccess({report})),
              catchError((error) => of(downloadReportFailure({error})))
            )
        }
      )
    )
  );

  loadReportValidationMessages$ = createEffect(() =>
    this.actions$.pipe(
      ofType(loadReportValidationMessages),
      switchMap((action) => {
          return this.reportService.getReportWithValidationMessages(action.reportId)
            .pipe(
              map((response) => {
                return loadReportValidationMessagesSuccess({
                  report: response
                })
              }),
              catchError((response) => of(loadReportValidationMessagesFailure(
                {
                  error: response
                }
              )))
            )
        }
      )
    )
  );

  constructor(
    private actions$: Actions,
    private store: Store<AppState>,
    private reportService: ReportService,
  ) {}
}
